import z from "zod";

export const createIdSchema = z.string().nullish();
